module.exports = __webpack_public_path__ + "static/img/scroll_down.7c508f0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/scroll_down.gif
// module id = 2BSk
// module chunks = 1